const productData = [
  {
    id: 1,
    name: "Pofin-2 Metallic Thigh High Pointy Toe Boots - Black",
    category: "Boots",
    price: "66.95",
    reviews: "342",
    rating: "4.6",
    image: "/img/101.webp",
    images: ["/img/101.webp", "/img/101a.webp"],
    size: ["5", "6", "7", "8", "9", "10", "11"],
    colors: ["Natural Black", "Warm White"],
    material: "Synthetic leather with metallic finish",
    description: [
      "Statement thigh-high silhouette with a sharp pointed toe for dramatic styling.",
      "Metallic-coated upper adds eye-catching shine while remaining lightweight.",
      "Cushioned insole provides surprising comfort for extended wear.",
      "Inside zipper and flexible shaft for easier on/off fit.",
      "Durable synthetic outsole designed for street and event wear.",
      "Perfect for pairing with dresses, skirts, or layered over trousers for high-fashion looks.",
    ],
    Features: [
      "Shiny metallic upper",
      "Pointed toe silhouette",
      "Cushioned footbed for all-day wear",
      "Secure inside zip closure",
      "Stable block heel for balance",
      "Durable synthetic outsole",
      "Available in multiple colors and sizes",
    ],
  },
  {
    id: 2,
    name: "Elarahh Belt Buckle Open Round Toe Heel Boots - Cow",
    category: "Boots",
    price: "66.95",
    reviews: "289",
    rating: "4.7",
    image: "/img/102.webp",
    images: ["/img/102.webp", "/img/102a.webp"],
    size: ["5", "6", "7", "8", "9", "10", "11"],
    colors: ["Charcoal", "Deep Red"],
    material: "Faux leather with buckle hardware",
    description: [
      "Western-inspired ankle boot with decorative belt buckle trim.",
      "Open rounded toe design blends comfort with runway-ready detailing.",
      "Padded collar and cushioned midsole for comfortable daytime wear.",
      "Textured outsole for improved traction on city streets.",
      "Versatile styling — pairs with denim, skirts, and tailored trousers.",
      "Made with easy-care materials for low maintenance.",
    ],
    Features: [
      "Decorative buckle hardware",
      "Rounded open toe",
      "Cushioned midsole",
      "Durable synthetic outsole",
      "Soft lining for comfort",
      "Available in multiple finishes",
    ],
  },
  {
    id: 3,
    name: "Icona Embroidery Thigh-High Cowboy Boots - Black",
    category: "Boots",
    price: "130.00",
    reviews: "214",
    rating: "4.5",
    image: "/img/103.webp",
    images: ["/img/103.webp", "/img/103a.webp"],
    size: ["5", "6", "7", "8", "9", "10", "11"],
    colors: ["Olive", "Mulberry"],
    material: "Embroidered synthetic upper",
    description: [
      "Tall cowboy boot with embroidered panels for a vintage-inspired finish.",
      "Structured shaft holds shape while offering a flattering leg line.",
      "Comfortable insole with moderate cushioning for longer wear.",
      "Stable heel height suitable for both day and evening looks.",
      "Decorative stitching and embroidery details elevate the design.",
    ],
    Features: [
      "Detailed embroidery",
      "Tall structured shaft",
      "Comfort footbed",
      "Textured outsole for grip",
      "Quality synthetic materials for longevity",
    ],
  },
  {
    id: 4,
    name: "Malinde Rhinestone Embelished Western Inpired Knee High Boots - Silver",
    category: "Boots",
    price: "82.90",
    reviews: "178",
    rating: "4.6",
    image: "/img/104.webp",
    images: ["/img/104.webp", "/img/104a.webp"],
    size: ["5", "6", "7", "8", "9", "10", "11"],
    colors: ["Mulberry", "Tan"],
    material: "Synthetic leather with rhinestone embellishments",
    description: [
      "Knee-high western silhouette adorned with sparkling rhinestones.",
      "Metallic silver finish for maximum impact at events and nights out.",
      "Padded insole balances fashion-forward looks with wearable comfort.",
      "Reinforced heel for long-lasting wear and stability.",
      "Crafted details that read like a premium statement piece.",
    ],
    Features: [
      "Rhinestone embellishments",
      "Knee-high shaft",
      "Metallic finish",
      "Padded insole",
      "Stable stacked heel",
      "Durable synthetic sole",
    ],
  },
  {
    id: 5,
    name: "Rosss Rhinestone Print Platform Heels - Leopard",
    category: "Heels",
    price: "34.95",
    reviews: "305",
    rating: "4.8",
    image: "/img/105.webp",
    images: ["/img/105.webp", "/img/105a.webp"],
    size: ["5", "6", "7", "8", "9", "10", "11"],
    colors: ["Neutral", "Gold"],
    material: "Printed synthetic upper",
    description: [
      "Platform heel with bold leopard print and rhinestone details for glam appeal.",
      "Raised platform reduces perceived heel height for easier walking.",
      "Lightweight construction balances dramatic aesthetics with comfort.",
      "Perfect statement shoe for parties or elevated daytime looks.",
      "Available in multiple colorways to match wardrobe staples.",
    ],
    Features: [
      "Platform sole",
      "Rhinestone trim",
      "Printed upper",
      "Cushioned footbed",
      "Secure ankle strap (where applicable)",
    ],
  },
  {
    id: 6,
    name: "Rosss Rhinestone Print Platform Heels - Zebra",
    category: "Heels",
    price: "44.95",
    reviews: "198",
    rating: "4.4",
    image: "/img/106.webp",
    images: ["/img/106.webp", "/img/106a.webp"],
    size: ["5", "6", "7", "8", "9", "10", "11"],
    colors: ["Plum Blur", "Beige"],
    material: "Canvas with printed finish",
    description: [
      "Eye-catching zebra platform heels with a modern sculpted silhouette.",
      "Comfort-focused footbed to offset elevated platform height.",
      "Durable outsole for confident strides on varied surfaces.",
      "A versatile showpiece that pairs with both casual and dressy outfits.",
    ],
    Features: [
      "Printed canvas upper",
      "Platform heel",
      "Cushioned insole",
      "Sturdy outsole",
    ],
  },
  {
    id: 7,
    name: "Hilda Faux Snakeskin Thigh High Cowboy Boots - Animal",
    category: "Boots",
    price: "74.95",
    reviews: "240",
    rating: "4.7",
    image: "/img/107.webp",
    images: ["/img/107.webp", "/img/107a.webp"],
    size: ["5", "6", "7", "8", "9", "10", "11"],
    colors: ["Mocha", "Heather"],
    material: "Faux snakeskin synthetic upper",
    description: [
      "Thigh-high cowboy-inspired boot with textured faux snakeskin surface.",
      "Designed to make a statement while remaining surprisingly lightweight.",
      "Comfort padding at the insole ensures longer wearability.",
      "Pairs well with mini dresses and layered market looks.",
      "Durable construction built for seasonal styling and repeat wear.",
    ],
    Features: [
      "Faux snakeskin texture",
      "Thigh-high shaft",
      "Cushioned footbed",
      "Stable heel",
      "Durable synthetic sole",
    ],
  },
  {
    id: 8,
    name: "Nanaye-2 Rhinestone Trim Open Toe High Heels - Animal",
    category: "Heels",
    price: "55.95",
    reviews: "190",
    rating: "4.8",
    image: "/img/108.webp",
    images: ["/img/108.webp", "/img/108a.webp"],
    size: ["5", "6", "7", "8", "9", "10", "11"],
    colors: ["Brown", "Olive"],
    material: "Synthetic upper with rhinestone trim",
    description: [
      "Open toe stiletto with sparkling trims for evening elegance.",
      "Slim heel and refined platform balance glamour with wearability.",
      "Cushioned footbed helps provide comfort through the night.",
      "Delicate straps hold the foot securely in place.",
    ],
    Features: [
      "Rhinestone trim",
      "Open toe design",
      "Slim stiletto heel",
      "Padded insole",
    ],
  },
  {
    id: 9,
    name: "Karine Animal Print Western Cowgirl Boots - Black",
    category: "Boots",
    price: "68.95",
    reviews: "256",
    rating: "4.7",
    image: "/img/109.webp",
    images: ["/img/109.webp", "/img/109a.webp"],
    size: ["5", "6", "7", "8", "9", "10", "11"],
    colors: ["Trail Green", "Stone"],
    material: "Synthetic blend upper",
    description: [
      "Western cowgirl styling updated with modern platform and print treatments.",
      "Durable upper and supportive midsole for street-friendly comfort.",
      "Statement-making silhouette that complements both skirts and denim.",
    ],
    Features: [
      "Western-inspired stitching",
      "Durable platform sole",
      "Comfort footbed",
    ],
  },
  {
    id: 10,
    name: "Elarahh Belt Buckle Open Round Toe Heel Boots - Black",
    category: "Boots",
    price: "66.95",
    reviews: "312",
    rating: "4.9",
    image: "/img/1010.webp",
    images: ["/img/1010.webp", "/img/1010a.webp"],
    size: ["5", "6", "7", "8", "9", "10", "11"],
    colors: ["Black", "Charcoal"],
    material: "Faux leather",
    description: [
      "Ankle-length western boot with buckle detailing and a comfortable heel height.",
      "Soft lining and cushioned insole make it suitable for extended wear.",
      "Classic styling balanced with contemporary finishes for versatile outfits.",
    ],
    Features: [
      "Decorative buckle",
      "Cushioned insole",
      "Stable heel",
      "Durable synthetic sole",
    ],
  },
  {
    id: 11,
    name: "Malinde Rhinestone Embelished Western Inpired Knee High Boots - Pink",
    category: "Boots",
    price: "82.90",
    reviews: "198",
    rating: "4.6",
    image: "/img/1011.webp",
    images: ["/img/1011.webp", "/img/1011a.webp"],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Charcoal", "Rose"],
    material: "Tree fiber knit with embellishments",
    description: [
      "Knee-high design finished with sparkling accents for elevated looks.",
      "Padded midsole increases comfort while maintaining a fashion-forward silhouette.",
      "Versatile colorways that transition from day to night.",
    ],
    Features: [
      "Embellished details",
      "Knee-high shaft",
      "Comfort cushioning",
    ],
  },
  {
    id: 12,
    name: "Karine Animal Print Western Cowgirl Boots - Pink",
    category: "Boots",
    price: "115.00",
    reviews: "267",
    rating: "4.5",
    image: "/img/1012.webp",
    images: ["/img/1012.webp", "/img/1012a.webp"],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Gunmetal", "Blush"],
    material: "Velvet and recycled fiber blend",
    description: [
      "Soft velvet overlays and bold prints create an on-trend western style.",
      "Comfort foam midsole supports all-day wear.",
      "Designed to stand out while remaining surprisingly wearable.",
    ],
    Features: [
      "Velvet accents",
      "Comfort midsole",
      "Durable outsole",
    ],
  },
  {
    id: 13,
    name: "Stika Rhinestone Fringe Western Boots - Black",
    category: "Boots",
    price: "74.95",
    reviews: "223",
    rating: "4.6",
    image: "/img/1013.webp",
    images: ["/img/1013.webp", "/img/1013a.webp"],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Taupe", "Stone"],
    material: "Corduroy & wool blend",
    description: [
      "Fringe and rhinestone details combine for a playful western aesthetic.",
      "Cushioned insole adds practicality to an otherwise showy design.",
      "Lightweight construction keeps the boots comfortable for events.",
    ],
    Features: [
      "Fringe detailing",
      "Rhinestone accents",
      "Cushioned footbed",
    ],
  },
  {
    id: 14,
    name: "Annamarie Lace-Up Knee High Heel Boots - Tan",
    category: "Boots",
    price: "82.90",
    reviews: "198",
    rating: "4.7",
    image: "/img/1014.webp",
    images: ["/img/1014.webp", "/img/1014a.webp"],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Cognac Swirl", "Black"],
    material: "Tree fiber upper",
    description: [
      "Lace-up knee high boots with a classic heel and timeless silhouette.",
      "Comfort-focused construction with a supportive midsole.",
      "Versatile styling that works for both casual and dressier looks.",
    ],
    Features: [
      "Lace-up closure",
      "Knee-high shaft",
      "Comfort midsole",
    ],
  },
  {
    id: 15,
    name: "Lish Velvet Rhinestone Thigh High Slouchy Western Boots - Black",
    category: "Boots",
    price: "82.90",
    reviews: "312",
    rating: "4.8",
    image: "/img/1015.webp",
    images: ["/img/1015.webp", "/img/1015a.webp"],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Leopard", "Ivory"],
    material: "Wool and velvet blend",
    description: [
      "Thigh-high slouchy boots with velvet texture and rhinestone embellishments.",
      "Designed to be a showpiece while offering comfortable wear.",
      "Pairs well with layered outfits and seasonal ensembles.",
    ],
    Features: [
      "Velvet texture",
      "Rhinestone embellishments",
      "Slouchy silhouette",
    ],
  },
  {
    id: 16,
    name: "Petra Punk Style Buckle Up Stiletto Heels - Black",
    category: "Heels",
    price: "46.95",
    reviews: "187",
    rating: "4.7",
    image: "/img/1016.webp",
    images: ["/img/1016.webp", "/img/1016a.webp"],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Neutral", "Olive"],
    material: "Tree fiber knit",
    description: [
      "Punk-inspired buckle straps and sleek stiletto heel for edgy elegance.",
      "Lightweight construction paired with a supportive footbed.",
      "Perfect for nights out when you want a statement shoe.",
    ],
    Features: [
      "Buckle strap detail",
      "Slim stiletto heel",
      "Supportive insole",
    ],
  },
  {
    id: 17,
    name: "Pofin-2 Metallic Thigh High Pointy Toe Boots - Pink",
    category: "Boots",
    price: "95.00",
    reviews: "234",
    rating: "4.6",
    image: "/img/1017.webp",
    images: ["/img/1017.webp", "/img/1017a.webp"],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Midnight Blue", "White"],
    material: "Metallic synthetic upper",
    description: [
      "Pink metallic thigh-high boots with a pointed toe and sculpted heel.",
      "Eye-catching finish suitable for special occasions and fashion-forward outfits.",
      "Comfortable midsole and stable heel design for better balance.",
    ],
    Features: [
      "Metallic finish",
      "Pointed toe",
      "Cushioned midsole",
    ],
  },
  {
    id: 18,
    name: "Kastel Denim Rainbow Rhinestone Platform Boots - Denim",
    category: "Boots",
    price: "82.90",
    reviews: "201",
    rating: "4.6",
    image: "/img/1018.jpg",
    images: ["/img/1018.jpg", "/img/1018a.jpg"],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Mulberry", "Sand"],
    material: "Denim upper with rhinestone accents",
    description: [
      "Denim platform boots with colorful rhinestone detailing for playful style.",
      "Platform sole gives lift while maintaining a wearable feel.",
      "Ideal for festival looks and bold street style combinations.",
    ],
    Features: [
      "Denim upper",
      "Platform sole",
      "Rhinestone accents",
    ],
  },
  {
    id: 19,
    name: "Lish Velvet Rhinestone Thigh High Slouchy Western Boots - Fuchsia",
    category: "Boots",
    price: "74.95",
    reviews: "276",
    rating: "4.8",
    image: "/img/1019.webp",
    images: ["/img/1019.webp", "/img/1019a.webp"],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Gunmetal", "Ivory"],
    material: "Wool velvet blend",
    description: [
      "Fuchsia velvet boots with rhinestone accents for vibrant statement looks.",
      "Designed to combine luxe texture with wearable construction.",
      "Comfortable footbed suitable for extended wear at events.",
    ],
    Features: [
      "Velvet upper",
      "Rhinestone decoration",
      "Comfort cushioning",
    ],
  },
  {
    id: 20,
    name: "Elarahh Belt Buckle Open Round Toe Heel Boots - Denim",
    category: "Boots",
    price: "108.00",
    reviews: "189",
    rating: "4.6",
    image: "/img/1020.webp",
    images: ["/img/1020.webp", "/img/1020a.webp"],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Black with Gunmetal", "Blush"],
    material: "Velvet & mixed fabric",
    description: [
      "Denim-look ankle boots with buckle-detailing and a rounded toe.",
      "Comfort-focused construction with supportive midsole and traction outsole.",
      "Great for seasonal styling and versatile outfit pairings.",
    ],
    Features: [
      "Buckle detail",
      "Comfort midsole",
      "Durable outsole",
    ],
  },
];

export default productData;
